import ResetPWDConfirm from './ResetPWDConfirm'

export default ResetPWDConfirm
